import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { InvalidateAndRotateAPIKeyRPC } from "./invalidateAndRotateApiKeyRPC";

export class InvalidateAndRotateAPIKeyRPCClientImpl extends InvalidateAndRotateAPIKeyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: InvalidateAndRotateAPIKeyRPC.Request): Promise<LeoRPCResult<InvalidateAndRotateAPIKeyRPC.Response, InvalidateAndRotateAPIKeyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "external-public-apis/InvalidateAndRotateAPIKey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      InvalidateAndRotateAPIKeyRPC.ResponseDTO,
      InvalidateAndRotateAPIKeyRPC.Errors.ErrorsDTO,
      InvalidateAndRotateAPIKeyRPC.Response,
      InvalidateAndRotateAPIKeyRPC.Errors.Errors
    >(
      response,
      "external-public-apis/InvalidateAndRotateAPIKey",
      InvalidateAndRotateAPIKeyRPC.Response.fromDTO,
      InvalidateAndRotateAPIKeyRPC.Errors.fromDTO
    );
  }
}
